var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container pb-5"},[_c('SectionTitle',{attrs:{"title":"Acuerdo Ministerial 191-2007"}}),_vm._m(0)],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center pt-5"},[_c('iframe',{staticStyle:{"width":"1000px","height":"1060px"},attrs:{"src":"pdfs/Acuerdo191-2007.pdf#toolbar=0","frameborder":"0"}})])
}]

export { render, staticRenderFns }